import utils from '../utils/utils'
const getSupuLabelUrl = "/api/supuLabel/getLabelList"
const getStoreListUrl = "/api/accountManage/queryDeptBAll"
const getCardListUrl = "/api/supuCard/getCardList"
const getMemberListUrl = "/api/supuMember/getSupuMemberList"
export default {
  getSupuLabel:(type,belongClass,callback)=>{
    utils.axiosMethods({
      method:"POST",
      url:getSupuLabelUrl,
      data:{
        type:type,
        belongClass:belongClass
      },
      callback:(res => {
        if(res.data.code == 0){
          if(typeof callback == "function"){
            callback(res.data.list);
          }
        }
      })
    })
  },
  getStoreList:(callback) => {
    utils.axiosMethods({
      method:"GET",
      url:getStoreListUrl,
      callback:(res => {
        if(res.data.code == 0){
          if(typeof callback == "function"){
            callback(res.data.list);
          }
        }
      })
    })
  },
  getCardList:(data,callback) => {
    utils.axiosMethods({
      method:"POST",
      url:getCardListUrl,
      data:data,
      callback:(res => {
        if(res.data.code == 0){
          if(typeof callback == "function"){
            callback(res.data.list);
          }
        }
      })
    })
  },
  getMemberList:(data,callback) => {
    utils.axiosMethods({
      method:"POST",
      url:getMemberListUrl,
      data:data,
      callback:(res => {
        if(res.data.code == 0){
          if(typeof callback == "function"){
            callback(res.data.list);
          }
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/supuService.js